export enum HomeClaimSubheading {
  StormDamageClaim = "Tell us what's been damaged",
  StormDamagedFenceClaim = "What sort of fence has been damaged?",
}
